import { render, staticRenderFns } from "./shareReform.vue?vue&type=template&id=3db6ec18"
import script from "./shareReform.vue?vue&type=script&lang=js"
export * from "./shareReform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports